import React, { type ComponentProps, useEffect } from 'react';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

import { Icon } from '../Icon/Icon';

export const RotatingIcon = (props: RotatingIconProps) => {
  const { style, duration, delay, ...iconProps } = props;

  const rotation = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [{ rotate: `${rotation.value}deg` }],
    };
  }, []);

  useEffect(() => {
    rotation.value = withRepeat(
      withSequence(
        withTiming(180, { duration, easing: Easing.elastic(0) }),
        withDelay(delay, withTiming(180, { duration: 0 })),
        withTiming(0, { duration, easing: Easing.elastic(0) }),
        withDelay(delay, withTiming(0, { duration: 0 })),
      ),
      -1,
      false,
    );
  }, [duration, delay, rotation]);

  return (
    <Animated.View style={[animatedStyle, style]}>
      <Icon {...iconProps} />
    </Animated.View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type RotatingIconProps = ComponentProps<typeof Icon> & {
  style?: ComponentProps<typeof Animated.View>['style'];
  duration: number;
  delay: number;
};
